import React, { useState } from 'react'
import { Link, useNavigate } from "react-router-dom"
import Select from 'react-select'
import unknown_car from "../Data/sample_images/unknown_car.png"
import car_data from "../Data/car_data.json"

const CompareOneCar = () => {
  //   state to store the user's input
  const [userInput, setUserInput] = useState({})

  //   Function to handle form
  const handleForm = (event) => {
    event.preventDefault()
    setUserInput((prevInput) => {
        return {
            ...prevInput,
            [event.target.name]: event.target.type === "checkbox" ? event.target.checked : event.target.value
        }
    })
  }

  //   using useNavigate Hook for 'more details' button
  const navigate = useNavigate()

  const moreDetails = () => {
    console.log(userInput.id) 
    navigate(`/browse/${userInput.id}`)
  }


  return (
    <>
      <section className='compare'>
            <div className="container compare-container">
                <h3 className="section-subtitle">AutoInsure</h3>
                <h1 className="section-title">Compare One Car</h1>
                <p className="section-caption">Choose a car of your choice, to view details about its make, engine-size & more.</p>
                <div className="compare-box-container compare-one">
                    <div className="compare-box">
                        <div className="compare-img-container one-img">
                            <img src={userInput.img ? userInput.img : unknown_car} alt="Car" />
                        </div>
                        <form className="compare-form" onChange={handleForm}>
                            <h2 className="compare-form-title">Add a Car</h2>
                            <Select 
                                options={car_data}
                                id="chooseMake"
                                onChange={setUserInput}
                                isSearchable
                                getOptionLabel={(option) => `${option.make} ${option.model} ${option.year}`}
                            />
                            <Link to="/comparetwocars">
                                <button className="btn btn-lg compare-two-btn">Compare Two Cars</button>
                            </Link>
                        </form>
                        <div className={userInput.id ? "compare-results-container" : "hide"}>
                            <h2 className="results-title">Your Car Results:</h2>
                            <div className="compare-results-row">
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Car Make</div>
                                    <div className="result-caption">{userInput.make}</div>
                                </div>
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Car Model</div>
                                    <div className="result-caption">{userInput.model}</div>
                                </div>
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Registration Year</div>
                                    <div className="result-caption">{userInput.year}</div>
                                </div>
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Colour</div>
                                    <div className="result-caption">{userInput.colour}</div>
                                </div>
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Transmission</div>
                                    <div className="result-caption">{userInput.transmission}</div>
                                </div>
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Fuel Type</div>
                                    <div className="result-caption">{userInput.fuel_type}</div>
                                </div>
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Tank Size</div>
                                    <div className="result-caption">{userInput.tank_size}</div>
                                </div>
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Bodystyle</div>
                                    <div className="result-caption">{userInput.bodystyle}</div>
                                </div>
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Doors</div>
                                    <div className="result-caption">{userInput.doors}</div>
                                </div>
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Capacity</div>
                                    <div className="result-caption">{userInput.capacity}</div>
                                </div>
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Insurance Group</div>
                                    <div className="result-caption">{userInput.insurance_group}</div>
                                </div>
                                <div className="compare-results-column">
                                    <div className="result-subtitle">Insurance Group</div>
                                    <div className="result-caption">from £{userInput.base_insurance} per year</div>
                                </div>
                                <div className="btn btn-md more-details" onClick={() => moreDetails()}>More Details</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </section>
    </>
  )
}

export default CompareOneCar
